// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_D_j","cls2":"ImpactHubModal-cls2_RmO ImpactHubModal-cls1_D_j"};